import React from 'react';
import EmbedPage from 'src/shared/components/EmbedPage/EmbedPage';
import { OPTIONS } from './constants/eventListenerOptions';

export default function EventListeners({ productSelected }) {
  return <EmbedPage options={OPTIONS} productSelected={productSelected}></EmbedPage>;
}
